export default __webpack_public_path__ + "resources/icons/d330-b6c2.webp";